import { normalizeDischargeCarePlanData } from '../Authentication/registerSession'

type getUpdatedDischargeCarePlanProps = {
  id: string
}

export const getUpdatedDischargeCarePlan = async (
  id
): getUpdatedDischargeCarePlanProps => {
  try {
    if (!id) {
      throw new Error('Patient ID can`t be null')
    }

    const body = {
      _id: id,
      // Needed for the BE to restart from scratch the session
      resetPlan: true
    }

    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/updateCarePlan`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${process.env.REACT_APP_BACKEND_MAYARED_TOKEN}`
        }
      }
    )

    const bodyRes = await res.json()

    if (bodyRes.error) {
      throw new Error(bodyRes.error.response.error.message || res.statusText)
    }

    return normalizeDischargeCarePlanData(bodyRes.carePlan)
  } catch (e) {
    throw e
  }
}
